import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class EscalaProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {}

  getFuncoesSemPessoa(entidade, idEntidade, pag, filtro, tipo = '') {
    return this.http
      .get<any>(this.baseUrl + '/escala/funcoes-sem-pessoa', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro,
          entidade: entidade,
          idEntidade: idEntidade,
          tipo: tipo,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          funcoes: data.body,
          pagination: pag,
        };
      });
  }

  getFuncoesPessoa(entidade, idEntidade, idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/escala/funcoes-pessoa', {
        entidade: entidade,
        idEntidade: idEntidade,
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  removerPessoaFuncao(idEscalaFuncaoPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/escala/remover-pessoa-funcao', {
        id: idEscalaFuncaoPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  addPessoaFuncao(entidade, idEntidade, idPessoa, idFuncao, idEscala) {
    return this.http
      .post<any>(this.baseUrl + '/escala/add-pessoa-funcao', {
        entidade: entidade,
        idEntidade: idEntidade,
        idPessoa: idPessoa,
        idFuncao: idFuncao,
        idEscala: idEscala,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  addPessoaFuncoes(entidade, idEntidade, pessoas, idFuncao, idEscala) {
    return this.http
      .post<any>(this.baseUrl + '/escala/add-pessoa-funcoes', {
        entidade: entidade,
        idEntidade: idEntidade,
        pessoas: pessoas,
        idFuncao: idFuncao,
        idEscala: idEscala,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getGrupos(filtro, tipoGrupo, regiao, dia, tipo, pag) {
    return this.http
      .get<any>(this.baseUrl + '/escala/get-grupos-escala', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro,
          tipoGrupo: tipoGrupo,
          regiao: regiao,
          dia: dia,
          tipo: tipo,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          grupos: data.body,
          pagination: pag,
        };
      });
  }

  getPessoas(filtro, grupo = '', entidade, idEntidade, idFuncao, pag) {
    return this.http
      .get<any>(this.baseUrl + '/escala/get-pessoas', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro,
          idFuncao: idFuncao,
          grupo: grupo,
          entidade: entidade,
          idEntidade: idEntidade,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          pessoas: data.body,
          pagination: pag,
        };
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/escala/escala.ts